module.exports = __webpack_public_path__ + "static/media/tetris.073cec69.jpg";